import type { Editor } from "@tiptap/core";
import {
  buildFloatingSessionSnapshot,
  isFloatingChoiceAtTokenPos,
} from "./session";
import type { DirectiveSuggestionStateRef } from "../logic/printTable";
import type { DirectiveSuggestionStorageSlice } from "./directiveSuggestionStorageTypes";

const getDirectiveSuggestionStorageSlice = (
  editor: Editor,
): DirectiveSuggestionStorageSlice | undefined =>
  editor.storage.directiveSuggestion;

export const syncFloatingBuilderChoiceStorage = (
  editor: Editor,
  stateRef: DirectiveSuggestionStateRef,
): void => {
  const storage = getDirectiveSuggestionStorageSlice(editor);
  if (storage == null) return;
  storage.floatingBuilderChoiceAtPos = buildFloatingSessionSnapshot(
    stateRef.builder,
    stateRef.directiveTokenFrom,
    stateRef.floatingChoiceFieldEl ?? null,
  ).floatingChoiceAtPos;
};

export const clearFloatingBuilderChoiceStorage = (editor: Editor): void => {
  const storage = getDirectiveSuggestionStorageSlice(editor);
  if (storage != null) {
    storage.floatingBuilderChoiceAtPos = null;
  }
};

export const floatingBuilderOwnsChoiceAtChipPos = (
  editor: Editor,
  getPos: () => number | undefined,
): boolean => isFloatingChoiceAtTokenPos(editor, getPos());

export const shouldChipShowChoiceUI = (
  editor: Editor,
  getPos: () => number | undefined,
  chipPopoverOpen: boolean,
): boolean =>
  chipPopoverOpen && !floatingBuilderOwnsChoiceAtChipPos(editor, getPos);
